<script>
    import CommonForm from './common_form.svelte';
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <div class="desktop">
        <div class="back-div">
            <div>
                <div class="process">
                    <p>Process</p>
                </div>
                <div class="process_x">
                    <p>
                        Our Application is a 4 step process, where you provied
                        the requierd information. This form costs $5 for
                        submission.
                    </p>
                </div>
            </div>
            <ul style="list-style: none;">
                {#each Array(3) as _, i}
                    <li class="vl" />
                {/each}
            </ul>
            <div class="front-div">
                <CommonForm />
            </div>
        </div>
    </div>
    <div class="mobile">
        <div class="back-div-mobile">
            <div style="position: absolute;">
                <p class="process-mobile">Process</p>

                <p class="process_x-mobile">
                    Our Application is a 4 step process, where you provied the
                    requierd information. This form costs $5 for submission.
                </p>
            </div>

            <div style="padding-top: 33vw;">
                <ul
                    style="list-style: none; display: flex; gap: 24.5vw;width: 75vw;padding-left: 15vw;"
                >
                    {#each Array(3) as _, i}
                        <li class="vl-mobile" />
                    {/each}
                </ul>
            </div>

            <div class="front-div-mobile">
                <CommonForm />
            </div>
        </div>
    </div>
</section>

<style>
    .back-div {
        position: relative;
        height: 36.812vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 2vw;
        display: flex;
        margin-bottom: -0.1vw;
        margin-top: 1.1vw;
    }
    .front-div {
        position: absolute;
        width: 100%;
        height: 35.384vw;
        background: #ffffff;
        border-bottom-left-radius: 2vw;
        border-bottom-right-radius: 2vw;
        left: 22.25vw;
        bottom: 1.6vw;
    }

    .process {
        font-size: 1.984vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 3vw;
        margin-top: 4.497vw;
    }
    .process_x {
        width: 15.013vw;
        font-size: 0.926vw;
        color: rgb(255 255 255);
        font-weight: 300;
        margin-left: 3vw;
    }
    .vl {
        margin-top: 1.984vw;
        border-radius: 0.5vw;
        width: 0.463vw;
        border-left: 0.5vw solid rgba(60, 116, 192, 1);
        height: 5.82vw;
        opacity: 0.3;
        margin-left: 0vw;
    }
    .vl:nth-child(2) {
        border-left: 0.5vw solid white;
        opacity: 100;
    }
    .back-div-mobile {
        position: relative;
        height: 260vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-top-left-radius: 8vw;
        border-top-right-radius: 8vw;
        margin-bottom: -0.2vw;
    }
    .process-mobile {
        font-size: 5.556vw;
        color: rgb(255 255 255);
        font-weight: 400;
        margin-left: 7.222vw;
        padding-top: 9.167vw;
    }
    .process_x-mobile {
        width: 73.889vw;
        font-size: 3.056vw;
        color: rgb(255 255 255);
        margin-left: 7.222vw;
    }
    .vl-mobile {
        border-radius: 0.5vw;
        border-left: 1.3vw solid rgba(60, 116, 192, 1);
        height: 15.460999999999999vw;
        opacity: 0.3;
        margin-left: 0vw;
        transform: rotate(90deg);
    }
    .vl-mobile:nth-child(2) {
        border-left: 1.3vw solid white;
        opacity: 100;
    }
    .front-div-mobile {
        position: absolute;
        width: 92.778vw;
        background: #ffffff;
        border-top-left-radius: 4.5vw;
        border-bottom-left-radius: 4.5vw;
        left: 7.222vw;
        padding-bottom: 5vw;
        top: 45vw;
    }
    .desktop {
        display: block;
        width: 100%;
        overflow: hidden;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
    }
</style>
